<nav class="navbar navbar-expand-lg navbar-dark darkBlue">
  <div class="container-fluid">
    <div>
      <button class="navbar-toggler ms-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
              aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      @if (showHomeButton) {
        <a class="navbar-brand text-white ms-4" href="#">{{ titleToShow }}</a>
      }
    </div>

    @if ($edlInfo | async; as edlInfo) {
      <span class="me-4 text-white fw-bolder">{{ edlInfo }}</span>
    }

    @if (fullname && fullname !== 'undefined undefined') {
      <div role="button">
        <span class="me-4 text-white">{{ fullname }}</span>
        <i (click)="onLogout()" title="Déconnexion" class="bi bi-box-arrow-right text-white"></i>
      </div>
    }
  </div>
</nav>
